/** Shared native app CTAs used across webviews. */

export const getMutualFundDetailCTA = ({
  isin,
  navigationStyle = 'PUSH'
}: {
  isin: string
  navigationStyle?: 'PUSH' | 'PUSH_REPLACEMENT'
}) => {
  return {
    type: 'CTA',
    ctaType: 'DEFAULT',
    method: 'POST',
    navigationStyle,
    url: '/v1/mutual-fund/explore',
    isNavigationDeferred: false,
    requestPayload: {
      postBackParams: {
        requester: 'OTHER'
      },
      inputData: {
        isin: `${isin}`
      }
    },
    navigateWithShuttleAnimation: false
  }
}

export const getEliteCTA = () => {
  return {
    type: 'CTA',
    ctaType: 'DEFAULT',
    method: 'GET',
    navigationStyle: 'PUSH',
    url: '/v2/portfolio/getElite'
  }
}

export const getOrdersTabCTA = () => {
  return {
    type: 'CTA',
    ctaType: 'DEFAULT',
    method: 'GET',
    navigationStyle: 'PUSH_AND_REMOVE_ALL',
    url: '/v1/powerup/user/home?tabTypeEnum=portfolio&subTabType=ORDERS'
  }
}

export const SUPPORT_CTA = {
  type: 'CTA',
  ctaType: 'DEFAULT',
  method: 'POST',
  navigationStyle: 'BOTTOM_SHEET',
  url: '/v1/contextual-messaging',
  isNavigationDeferred: false,
  requestPayload: {
    postBackParams: {
      supportTouchPointEnum: 'ACCOUNT_SETTINGS'
    }
  }
}

/** Opens a native static-site screen via `/v1/user/static-site`. */
export const getStaticSiteCta = (staticSiteType: string) => ({
  type: 'CTA',
  method: 'POST',
  navigationStyle: 'PUSH',
  url: '/v1/user/static-site',
  requestPayload: {
    postBackParams: { staticSiteType }
  }
})
